module.exports = __webpack_public_path__ + "img/home_15_1.b390cdca.png";